export const emailSendTechnicalSupport = async (payload: any) => {
    const response = await fetch(
        `${process.env.REACT_APP_API_URL}/email/send-technical-support`,
        {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify(payload),
        }
      );
    return await response.json();
  };